import React from 'react';
import styled from 'styled-components';
import {
  Accordion,
  Text,
  TextTag,
  WhiteSpace,
} from '@volkswagen-onehub/components-core';
import {FaqListProps} from '@volkswagen-onehub/whitelabel-e-mobility-commons';

export function FaqList({items, refHandle}: FaqListProps): JSX.Element {
  const [openId, setOpenId] = React.useState<string | undefined>(undefined);

  React.useImperativeHandle(
    refHandle,
    () => ({
      openAndFocus: (itemId: string) => {
        setOpenId(itemId);

        document.getElementById(itemId)?.scrollIntoView({
          behavior: 'smooth',
          block: 'center',
          inline: 'nearest',
        });

        /**
         * The setTimeout is a hack necessary for VW because we are only able to set focus
         * on elements after the layer animation is over / after the FocusLock
         * got removed. TODO: upstream fix
         */

        window.setTimeout(() => {
          document
            .getElementById(itemId)
            ?.getElementsByTagName('button')[0]
            ?.focus();
        }, 400);
      },
    }),
    [setOpenId]
  );

  return (
    <>
      {items.map(({id, question, answer}) => (
        <Accordion
          isOpen={id === openId}
          onClick={() => {
            setOpenId(openId === id ? undefined : id);
          }}
          key={id}
          id={id}
          headline={
            <TextWrapper>
              <Text tag={TextTag.h3} bold>
                {question}
              </Text>
            </TextWrapper>
          }
        >
          <TextWrapper>
            <Text tag={TextTag.span} whiteSpace={WhiteSpace.preWrap}>
              {answer}
            </Text>
          </TextWrapper>
        </Accordion>
      ))}
    </>
  );
}

const TextWrapper = styled.div`
  span,
  h3 {
    word-break: normal;
    hyphens: auto;
    overflow-wrap: anywhere;
  }
`;
